import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useProductPackagingEdit = () => {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const editRequest = ({
    guid,
    packageName,
    description,
    packageLenght,
    identityType,
    identityCodeGuid,
    parentPackGuid,
    splittable,
    requiredScanning,
    handleRefetch,
  }) => {
    setLoading(true);
    axiosClient
      .put(`Product/Branch/Packaging/Update`, {
        guid,
        display: packageName,
        description,
        count: packageLenght,
        identityType,
        identityCodeGuid,
        parentPackGuid,
        splittable,
        requiredScanning,
      })
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(res.data?.message, { variant: 'success' });
          handleRefetch();
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };
  return [editRequest, loading];
};

export default useProductPackagingEdit;
